







































import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { ParamItemDto } from '@/services/dataprocess';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
@Component
export default class DataprocessFlinksql5 extends mixins(DictMixin) {
  @PropSync('paramsConfig') syncParamList!: ParamItemDto[];
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;

  headStyle = 'fontWeight: 600;';

  addList() {
    this.syncParamList.push({
      fieldCode: '',
      fieldName: '',
      fieldType: '',
      fieldValue: '',
    });
  }

  removeList(index: number) {
    this.syncParamList.splice(index, 1);
  }

  async confirm() {
    const must: { field: 'fieldCode' | 'fieldValue' ; msessage: string }[] = [
        { field: 'fieldCode', msessage: '参数编码不能为空' },
        { field: 'fieldValue', msessage: '参数值不能为空' },
    ];
    if (this.syncParamList && this.syncParamList.length > 0) {
      for (let i = 0; i < this.syncParamList.length; i++) {
        let v = this.syncParamList[i];
        for (let val of must) {
          if (!v[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
      }
    }
    this.syncVisible = false;
    return true;
  }
}
